'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

FatigueThresholdLabelDirective=class FatigueThresholdLabelDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['leftMargin','areaWidth','minRange','maxRange','currentValue'];
}

get templateUrl(){
return'/templates/directives/fatigueThresholdLabelDirective/fatigueThresholdLabelTemplate';
}

get controller(){
return FatigueThresholdLabelDirectiveController;
}

factory(){
let directive=super.factory();
directive.replace=!0;
return directive;
}};let


FatigueThresholdLabelDirectiveController=class FatigueThresholdLabelDirectiveController{
constructor(){
this._labelWidth=120;
}

get _leftOuterMargin(){
return this.leftMargin-this._labelWidth/2;
}

get _leftInnerPercent(){
return(this.currentValue-this.minRange)/(this.maxRange-this.minRange);
}

get _leftInnerMargin(){
return this.areaWidth*this._leftInnerPercent;
}

get leftPosition(){
return this._leftOuterMargin+this._leftInnerMargin;
}};



module.exports=FatigueThresholdLabelDirective;
//# sourceMappingURL=fatigueThresholdLabelDirective.js.map
